/* Esse objeto reúne constantes para códigos de permissões de recursos e rotas. O objetivo é ter uma estrutura
semelhante ao desktop para manter a compatibilidade de permissões durante a migração desktop-web */

export const PERMS = {
  /* MÓDULO PDV MÓVEL / ADM PDV MÓVEL */
  ADMPDVMOVEL_MENU_SOLICITACOES_PDV: 32001,
  ADMPDVMOVEL_MENU_CADASTRO_USUARIO: 32002,
  ADMPDVMOVEL_MENU_CONFIGURACOES_GERAL: 32003,

  /* MÓDULO ADM APPCLI */
  // cadastro
  ADMAPPCLI_MENU_CADASTRO_CLIENTE: 36004,
  ADMAPPCLI_MENU_CADASTRO_SERVICO: 36003,
  ADMAPPCLI_MENU_CADASTRO_USUARIO: 36001,

  // procedimentos
  ADMAPPCLI_MENU_PROCEDIMENTOS_CONSULTA_PAX: 36008,
  ADMAPPCLI_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 36005,

  // passenger
  ADMAPPCLI_MENU_PASSENGER_ANALYTIC: 36007,
  ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO: 36006,

  // opções
  ADMAPPCLI_MENU_OPCOES_AGENDA_TELEFONICA: 36009,

  // configurações
  ADMAPPCLI_MENU_CONFIGURACOES_GERAL: 36002,

  /* MÓDULO ADM PARTNER */
  // cadastro
  ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA: 44001,
  ADMPARTNER_MENU_CADASTRO_FORNECEDOR: 44004,
  ADMPARTNER_MENU_CADASTRO_USUARIO: 44003,
  ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER: 44002,

  // opções
  ADMPARTNER_MENU_OPCOES_AGENDA_TELEFONICA: 44006,

  // configurações
  ADMPARTNER_MENU_CONFIGURACOES_GERAL: 44005,

  /* MÓDULO CRM */
  // cadastro
  CRM_MENU_CADASTRO_CANAL_VENDA: 21013,
  CRM_MENU_CADASTRO_CIDADE: 21003,
  CRM_MENU_CADASTRO_CLIENTE: 21021,
  CRM_MENU_CADASTRO_CONTATO_AVULSO: 21045,
  CRM_MENU_CADASTRO_GRUPO_CONTATO_AVULSO: 21002,
  CRM_MENU_CADASTRO_SAC_CLASSIFICACAO_ATENDIMENTO: 21015,
  CRM_MENU_CADASTRO_SAC_SUBCLASSIFICACAO_ATENDIMENTO: 21016,
  CRM_MENU_CADASTRO_USUARIO: 21004,

  // procedimentos
  CRM_ALTERAR_ATENDIMENTO_SAC: 21018,
  CRM_EXCLUIR_ATENDIMENTO_SAC: 21019,
  CRM_MENU_PROCEDIMENTOS_ATENDIMENTO_SAC: 21017,
  CRM_MENU_PROCEDIMENTOS_CONCIERGE_ENVIO: 21048,
  CRM_MENU_PROCEDIMENTOS_CONCIERGE_IMPORTACAO: 21047,
  CRM_MENU_PROCEDIMENTOS_ENVIO_COMUNICADO_SERVICO_SMS: 21029,
  CRM_MENU_PROCEDIMENTOS_ENVIO_MENSAGEM_PUSH_ORDEM_SERVICO: 21033,
  CRM_MENU_PROCEDIMENTOS_ENVIO_MENSAGEM_PUSH_SERVICO: 21032,
  CRM_MENU_PROCEDIMENTOS_EXTRACAO_DADO: 21028,
  CRM_MENU_PROCEDIMENTOS_FOLLOW_UP: 21005,
  CRM_MENU_PROCEDIMENTOS_MAPA_TRANSPORTE: 21049,
  CRM_MENU_PROCEDIMENTOS_ORCAMENTO: 21026,
  CRM_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 21022,
  CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_DISPONIBILIZA_RESPOSTA: 21031,
  CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_QUESTAO: 21024,
  CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_QUESTIONARIO: 21023,
  CRM_MENU_PROCEDIMENTOS_QUESTIONARIO_DINAMICO_RESPOSTA: 21027,
  CRM_MENU_PROCEDIMENTOS_WHATSAPP_ENVIO: 21046,
  CRM_MENU_PROCEDIMENTOS_WHATSAPP_MONITOR_MENSAGEM: 21044,
  CRM_REABRIR_ATENDIMENTO_ENCERRADO: 21020,

  // newsletter
  CRM_MENU_NEWSLETTER_EMAIL_AVULSO: 21011,
  CRM_MENU_NEWSLETTER_NEWSLETTER: 21012,
  CRM_MENU_NEWSLETTER_REMESSA_EMAIL: 21007,

  // relatórios
  CRM_MENU_RELATORIOS_ANIVERSARIANTE: 21038,
  CRM_MENU_RELATORIOS_CONFERENCIA_STATUS_SMS: 21037,
  CRM_MENU_RELATORIOS_ENVIO_COMUNICADO_SERVICO_SMS: 21030,
  CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_CLIENTE_OS: 21042,
  CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_CONCIERGE: 21051,
  CRM_MENU_RELATORIOS_ENVIO_MENSAGEM_WHATSAPP: 21040,
  CRM_MENU_RELATORIOS_GRAFICO_QUESTIONARIO_MULTIPLA_ESCOLHA: 21036,
  CRM_MENU_RELATORIOS_LOG: 21050,
  CRM_MENU_RELATORIOS_LOGIN_LOCALIZADOR_PAX: 21041,
  CRM_MENU_RELATORIOS_OS_EXTRA_PERIODO: 21054,
  CRM_MENU_RELATORIOS_OS_HOTEL: 21053,
  CRM_MENU_RELATORIOS_PRODUCAO_CANAL_VENDA: 21014,
  CRM_MENU_RELATORIOS_QUESTIONARIO_DINAMICO: 21025,
  CRM_MENU_RELATORIOS_RESUMO_PAX_SERVICO_PERIODO: 21052,
  CRM_MENU_RELATORIOS_RESUMO_STATUS_MENSAGEM: 21034,
  CRM_MENU_RELATORIOS_RETORNO_QUESTIONARIO: 21035,

  // opções
  CRM_MENU_OPCOES_AGENDA_TELEFONICA: 21055,
  CRM_MENU_OPCOES_COPIA_SEGURANCA: 21008,
  CRM_MENU_OPCOES_MODELO_RELATORIO: 21056,

  // configurações
  CRM_ALTERAR_CONFIGURACAO_PROVEDOR_WHATSAPP: 21043,
  CRM_MENU_CONFIGURACOES_GERAL: 21010,

  /* MÓDULO ESTOQUE */
  // cadastro
  ESTOQUE_MENU_CADASTRO_CIDADE: 23010,
  ESTOQUE_MENU_CADASTRO_FICHA_TECNICA: 23037,
  ESTOQUE_MENU_CADASTRO_FORNECEDOR: 23008,
  ESTOQUE_MENU_CADASTRO_FUNCIONARIO: 23009,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_CLASSIFICACAO: 23004,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_GRUPO: 23002,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_BOX: 23030,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_CORREDOR: 23027,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_ESTANTE: 23028,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_PRATELEIRA: 23029,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_MERCADORIA: 23005,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_SUBGRUPO: 23003,
  ESTOQUE_MENU_CADASTRO_MODELO_DOCUMENTO_FISCAL: 23031,
  ESTOQUE_MENU_CADASTRO_REQUISICAO_PREDEFINIDA: 23006,
  ESTOQUE_MENU_CADASTRO_SETOR: 23007,
  ESTOQUE_MENU_CADASTRO_UNIDADE: 23001,
  ESTOQUE_MENU_CADASTRO_USUARIO: 23011,

  // estoque
  ESTOQUE_CANCELAR_REQUISICAO: 23046,
  ESTOQUE_CONFIRMAR_REQUISICAO: 23044,
  ESTOQUE_DEVOLVER_REQUISICAO: 23045,
  ESTOQUE_MENU_ESTOQUE_ACERTO: 23015,
  ESTOQUE_MENU_ESTOQUE_AGRUPAMENTO_NF_GERACAO_CONTA_PAGAR: 23026,
  ESTOQUE_MENU_ESTOQUE_ENTRADA_MERCADORIA: 23012,
  ESTOQUE_MENU_ESTOQUE_FECHAMENTO_MENSAL: 23016,
  ESTOQUE_MENU_ESTOQUE_REQUISICAO: 23013,
  ESTOQUE_MENU_ESTOQUE_RESUMO_REQUISICAO: 23048,
  ESTOQUE_MENU_ESTOQUE_TRANSFERENCIA: 23014,

  // relatórios
  ESTOQUE_MENU_RELATORIOS_CONTROLE_VALIDADE: 23047,
  ESTOQUE_MENU_RELATORIOS_ENTRADA_DEVOLUCAO: 23017,
  ESTOQUE_MENU_RELATORIOS_ESTOQUE_MINIMO_ALMOXARIFADO: 23042,
  ESTOQUE_MENU_RELATORIOS_ETIQUETA_CODIGO_BARRA_GRADE_MERCADORIA: 23038,
  ESTOQUE_MENU_RELATORIOS_ETIQUETA_MERCADORIA: 23032,
  ESTOQUE_MENU_RELATORIOS_FICHA_MERCADORIA: 23025,
  ESTOQUE_MENU_RELATORIOS_INVENTARIO: 23022,
  ESTOQUE_MENU_RELATORIOS_LISTAGEM_MERCADORIA: 23040,
  ESTOQUE_MENU_RELATORIOS_LOG: 23033,
  ESTOQUE_MENU_RELATORIOS_MOVIMENTACAO_MERCADORIA: 23019,
  ESTOQUE_MENU_RELATORIOS_MOVIMENTO_PRODUTO_VENDA: 23039,
  ESTOQUE_MENU_RELATORIOS_REQUISICAO: 23018,
  ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA: 23021,
  ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA_DATA: 23036,
  ESTOQUE_MENU_RELATORIOS_SALDO_SETOR: 23041,
  ESTOQUE_MENU_RELATORIOS_SALDO_SETOR_DATA: 23043,
  ESTOQUE_MENU_RELATORIOS_ULTIMA_COMPRA: 23020,
  ESTOQUE_MENU_RELATORIOS_VALIDADE: 23049,

  // opções
  ESTOQUE_MENU_OPCOES_COPIA_SEGURANCA: 23023,
  ESTOQUE_MENU_OPCOES_MODELO_RELATORIO: 23034,
  ESTOQUE_MENU_OPCOES_REORGANIZAR_ESTOQUE: 23035,
  ESTOQUE_MENU_OPCOES_REORGANIZAR_FICHA_ESTOQUE: 23050,

  // configurações
  ESTOQUE_MENU_CONFIGURACOES_GERAL: 23024,

  /* MÓDULO FINANÇAS */
  // cadastro
  FINANCAS_ALTERAR_CENTRO_RECEITA_DESPESA: 22040,
  FINANCAS_ALTERAR_PROJETO: 22076,
  FINANCAS_CADASTRAR_CENTRO_RECEITA_DESPESA: 22039,
  FINANCAS_CADASTRAR_PROJETO: 22075,
  FINANCAS_EXCLUIR_CENTRO_RECEITA_DESPESA: 22041,
  FINANCAS_EXCLUIR_PROJETO: 22077,
  FINANCAS_MENU_CADASTRO_ADQUIRENTE: 22102,
  FINANCAS_MENU_CADASTRO_BANCO: 22005,
  FINANCAS_MENU_CADASTRO_CARTAO_CREDITO: 22031,
  FINANCAS_MENU_CADASTRO_CENTRO_RECEITA_DESPESA: 22003,
  FINANCAS_MENU_CADASTRO_CIDADE: 22009,
  FINANCAS_MENU_CADASTRO_CLIENTE: 22033,
  FINANCAS_MENU_CADASTRO_CONTA_CORRENTE: 22004,
  FINANCAS_MENU_CADASTRO_FERIADO: 22043,
  FINANCAS_MENU_CADASTRO_FORNECEDOR: 22007,
  FINANCAS_MENU_CADASTRO_FUNCIONARIO: 22008,
  FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO: 22001,
  FINANCAS_MENU_CADASTRO_MULTI_PONTO_CARTAO_CREDITO: 22053,
  FINANCAS_MENU_CADASTRO_ORCAMENTO_RECEITA_DESPESA: 22096,
  FINANCAS_MENU_CADASTRO_PROJETO: 22055,
  FINANCAS_MENU_CADASTRO_RETENCAO_IMPOSTO: 22056,
  FINANCAS_MENU_CADASTRO_SETOR: 22006,
  FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO: 22002,
  FINANCAS_MENU_CADASTRO_TRANSACAO_FINANCEIRA: 22058,
  FINANCAS_MENU_CADASTRO_USUARIO: 22010,

  // financeiro
  FINANCAS_ALTERAR_CENTRO_CONTA_PAGAR_RECEBER_BAIXA_INDIVIDUALMENTE: 22083,
  FINANCAS_ALTERAR_COMPLEMENTO_CONTA_PAGAR_PAGA: 22093,
  FINANCAS_ALTERAR_DATA_LANCAMENTO_CONTA_CORRENTE_ORIGINADO_FORMA_BANCO_FRONT: 22094,
  FINANCAS_ALTERAR_OBSERVACAO_CONTA_RECEBER_BAIXADA: 22103,
  FINANCAS_EXCLUIR_CONTA_PAGAR: 22064,
  FINANCAS_EXCLUIR_CONTA_RECEBER: 22065,
  FINANCAS_EXCLUIR_MOVIMENTO_CONTA_CORRENTE: 22066,
  FINANCAS_MARCAR_ITEM_CONFERIDO_FATURAMENTO: 22092,
  FINANCAS_MENU_FINANCEIRO_CHEQUE_EMISSAO: 22016,
  FINANCAS_MENU_FINANCEIRO_CHEQUE_LIBERACAO: 22015,
  FINANCAS_MENU_FINANCEIRO_CHEQUE_RECEBIDO: 22017,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_ANALISE_RECEITA_DESPESA_CENTRO: 22072,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CLIENTE: 22060,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CONCILIACAO_BANCARIA: 22038,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_CONCILIACAO_BANCARIA_ARQUIVO_OFC_OFX: 22078,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_FORNECEDOR: 22054,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_LANCAMENTO: 22011,
  FINANCAS_MENU_FINANCEIRO_CONTA_CORRENTE_TRANSFERENCIA: 22012,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_CLIENTE: 22028,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_PROMOTOR: 22106,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_COMISSAO_VENDEDOR: 22027,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_CONTROLE_INCENTIVO_VENDEDOR: 22084,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_LANCAMENTO: 22013,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PAGAMENTO_FORNECEDOR: 22026,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PARCELAMENTO: 22042,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_CONSOLIDADO: 22090,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_DISPONIBILIDADE_OPCIONAL: 22073,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_LOCACAO_VEICULO: 22098,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_OPCIONAL: 22107,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PACOTE: 22097,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_AEREO: 22074,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_FORNECEDOR_ESCALA: 22048,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_PAGAMENTO_HOSPEDAGEM: 22057,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_RETENCAO: 22067,
  FINANCAS_MENU_FINANCEIRO_CONTA_PAGAR_PROVISIONAMENTO_SEGURO_VIAGEM: 22085,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_EMISSAO_BOLETO: 22089,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_ENVIO_SPC: 22030,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_LANCAMENTO: 22014,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PARCELAMENTO: 22032,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PROVISIONAMENTO_ADICIONAL: 22101,
  FINANCAS_MENU_FINANCEIRO_CONTA_RECEBER_PROVISIONAMENTO_SETOR: 22108,
  FINANCAS_MENU_FINANCEIRO_CREDITO_DEVOLVER: 22052,
  FINANCAS_MENU_FINANCEIRO_DESPESA_FIXA: 22109,
  FINANCAS_MENU_FINANCEIRO_DOCUMENTO_EMPRESA: 22100,
  FINANCAS_MENU_FINANCEIRO_EMISSAO_RECIBO: 22018,
  FINANCAS_MENU_FINANCEIRO_FATURAMENTO_CLIENTE: 22045,
  FINANCAS_MENU_FINANCEIRO_FECHAMENTO: 22044,
  FINANCAS_MENU_FINANCEIRO_INTEGRACAO_ENVISION_IMPORTAR_DADOS_TRAVEL_AGENT: 22068,
  FINANCAS_MENU_FINANCEIRO_INTEGRACAO_ENVISION_PROVISIONAMENTO_RECEBIMENTO: 22070,
  FINANCAS_REALIZAR_ALTERACAO_EMPRESA_CONTA_PAGAR_RECEBER_MULTI_EMPRESA: 22086,
  FINANCAS_REALIZAR_ESTORNO_FATURAMENTO: 22047,

  // relatórios
  FINANCAS_MENU_RELATORIOS_BALANCETE_ENTRADA_SAIDA: 22021,
  FINANCAS_MENU_RELATORIOS_BALANCETE_PERIODO: 22050,
  FINANCAS_MENU_RELATORIOS_CONTA_PAGAR: 22095,
  FINANCAS_MENU_RELATORIOS_CONTA_PAGAR_APROPRIACAO: 22087,
  FINANCAS_MENU_RELATORIOS_CONTA_RECEBER_APROPRIACAO: 22088,
  FINANCAS_MENU_RELATORIOS_CUSTO_SETOR: 22116,
  FINANCAS_MENU_RELATORIOS_DEMONSTRATIVO_DESPESA_FORNECEDOR: 22036,
  FINANCAS_MENU_RELATORIOS_DEMONSTRATIVO_RECEITA_DESPESA: 22037,
  FINANCAS_MENU_RELATORIOS_DESPESA_CENTRO_CUSTO_FORNECEDOR: 22034,
  FINANCAS_MENU_RELATORIOS_EXTRATO: 22019,
  FINANCAS_MENU_RELATORIOS_EXTRATO_CONTA_CORRENTE_CLIENTE: 22061,
  FINANCAS_MENU_RELATORIOS_EXTRATO_CONTA_CORRENTE_FORNECEDOR: 22059,
  FINANCAS_MENU_RELATORIOS_FATURAMENTO_ANUAL_CLIENTE: 22051,
  FINANCAS_MENU_RELATORIOS_FLUXO_CAIXA: 22062,
  FINANCAS_MENU_RELATORIOS_FLUXO_CAIXA_AGRUPADO_PERIODO: 22105,
  FINANCAS_MENU_RELATORIOS_IR: 22110,
  FINANCAS_MENU_RELATORIOS_LIMITE_CREDITO_CLIENTE: 22071,
  FINANCAS_MENU_RELATORIOS_LOG: 22023,
  FINANCAS_MENU_RELATORIOS_MOVIMENTO_CONTA_CORRENTE: 22049,
  FINANCAS_MENU_RELATORIOS_MOVIMENTO_CONTA_CORRENTE_AGRUPADO: 22099,
  FINANCAS_MENU_RELATORIOS_PLANO_60_25_15: 22111,
  FINANCAS_MENU_RELATORIOS_PROJECAO_FATURAMENTO_PACOTE: 22046,
  FINANCAS_MENU_RELATORIOS_RECEITA_CENTRO_RECEITA_CLIENTE: 22035,
  FINANCAS_MENU_RELATORIOS_RECEBIMENTO_CLIENTE: 22029,
  FINANCAS_MENU_RELATORIOS_RESUMO_PROVISIONAMENTO_PAGAR_RECEBER: 22091,
  FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE: 22020,
  FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE_CLIENTE: 22081,
  FINANCAS_MENU_RELATORIOS_RESUMO_SALDO_CONTA_CORRENTE_FORNECEDOR: 22082,
  FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RECIBO_RECEBIMENTO: 22112,
  FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_AGRUPADO: 22115,
  FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_CONTA_PAGAR: 22114,
  FINANCAS_MENU_RELATORIOS_TRAVEL_AGENT_RESULTADO_CONTA_RECEBER: 22113,
  FINANCAS_MENU_RELATORIOS_VARIACAO_CAMBIAL_PAGAMENTO: 22079,
  FINANCAS_MENU_RELATORIOS_VARIACAO_CAMBIAL_RECEBIMENTO: 22080,

  // opções
  FINANCAS_MENU_OPCOES_AGENDA_TELEFONICA: 22117,
  FINANCAS_MENU_OPCOES_COPIA_SEGURANCA: 22022,
  FINANCAS_MENU_OPCOES_EXPORTACAO_CONTABIL: 22104,
  FINANCAS_MENU_OPCOES_EXPORTACAO_DEFONTANA: 22119,
  FINANCAS_MENU_OPCOES_EXPORTAR_IMPORTAR_LAYOUT_A2X: 22063,
  FINANCAS_MENU_OPCOES_IMPORTACAO_DOMINIO_FOLHA_PAGAMENTO: 22118,
  FINANCAS_MENU_OPCOES_MODELO_RELATORIO: 22024,
  FINANCAS_MENU_OPCOES_TRANSFERENCIA: 22069,

  // configurações
  FINANCAS_MENU_CONFIGURACOES_GERAL: 22025,

  /* MÓDULO FRONT */
  // cadastro
  FRONT_INFORMAR_CLIENTE_ESTRANGEIRO: 12195,
  FRONT_INFORMAR_FORNECEDOR_ESTRANGEIRO: 12213,
  FRONT_MENU_CADASTRO_CIDADE: 12013,
  FRONT_MENU_CADASTRO_CLIENTE_CATEGORIA: 12008,
  FRONT_MENU_CADASTRO_CLIENTE_CLIENTE: 12009,
  FRONT_MENU_CADASTRO_ESTADO: 12015,
  FRONT_MENU_CADASTRO_EVENTO: 12153,
  FRONT_MENU_CADASTRO_FERIADO: 12103,
  FRONT_MENU_CADASTRO_FORNECEDOR_CATEGORIA: 12007,
  FRONT_MENU_CADASTRO_FORNECEDOR_FORNECEDOR: 12006,
  FRONT_MENU_CADASTRO_FORNECEDOR_HOTEL_CARACTERISTICA_APARTAMENTO: 12105,
  FRONT_MENU_CADASTRO_FORNECEDOR_HOTEL_TIPO_APARTAMENTO: 12104,
  FRONT_MENU_CADASTRO_FUNCIONARIO: 12012,
  FRONT_MENU_CADASTRO_LOCAL_DISTANCIA: 12048,
  FRONT_MENU_CADASTRO_LOCAL_LOCAL: 12047,
  FRONT_MENU_CADASTRO_LOCAL_ZONA: 12209,
  FRONT_MENU_CADASTRO_LOGRADOURO: 12014,
  FRONT_MENU_CADASTRO_META_VENDEDOR_GRUPO: 12075,
  FRONT_MENU_CADASTRO_ORCAMENTO_ROTEIRO_DESPESA: 12107,
  FRONT_MENU_CADASTRO_ORCAMENTO_ROTEIRO_ROTEIRO: 12106,
  FRONT_MENU_CADASTRO_PAIS: 12110,
  FRONT_MENU_CADASTRO_PROMOTOR: 12283,
  FRONT_MENU_CADASTRO_SERVICO_CATEGORIA: 12002,
  FRONT_MENU_CADASTRO_SERVICO_MENU_SUGESTIVO: 12124,
  FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO: 12138,
  FRONT_MENU_CADASTRO_SERVICO_PACOTE: 12081,
  FRONT_MENU_CADASTRO_SERVICO_SERVICO: 12003,
  FRONT_MENU_CADASTRO_SERVICO_TABELA_PACOTE: 12229,
  FRONT_MENU_CADASTRO_SETOR: 12005,
  FRONT_MENU_CADASTRO_TARIFARIO_CONTROLE_ATIVIDADE_TRANSPORTE: 12230,
  FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_FORNECEDOR: 12144,
  FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_FORNECEDOR_SERVICO: 12282,
  FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_GUIA: 12145,
  FRONT_MENU_CADASTRO_TARIFARIO_CUSTO_VENDA_HOTEL: 12108,
  FRONT_MENU_CADASTRO_TARIFARIO_PROMOCAO_HOTELARIA: 12281,
  FRONT_MENU_CADASTRO_TARIFARIO_VENDA_SERVICO: 12001,
  FRONT_MENU_CADASTRO_USUARIO: 12016,
  FRONT_MENU_CADASTRO_VEICULO_TIPO: 12045,
  FRONT_MENU_CADASTRO_VEICULO_VEICULO: 12046,
  FRONT_MENU_CADASTRO_VENDEDOR: 12082,
  FRONT_MENU_CADASTRO_VOO_RODOVIARIO: 12004,

  // procedimentos
  FRONT_ALTERAR_CLIENTE_SERVICO: 12059,
  FRONT_ALTERAR_EMBARQUE_OUTRA_DATA: 12151,
  FRONT_ALTERAR_ESCALA: 12132,
  FRONT_ALTERAR_MARKUP_SERVICO_AEREO: 12192,
  FRONT_ALTERAR_OBSERVACAO_SERVICO_PAGO: 12130,
  FRONT_ALTERAR_VALOR_COMISSAO_VENDEDOR_OS: 12272,
  FRONT_ALTERAR_VALOR_SERVICO: 12055,
  FRONT_ALTERAR_VENDEDOR_SERVICO: 12058,
  FRONT_BLOQUEAR_DESBLOQUEAR_GRUPO: 12163,
  FRONT_BLOQUEAR_ESCALA: 12217,
  FRONT_CANCELAR_ITEM_OS: 12023,
  FRONT_CANCELAR_OS: 12020,
  FRONT_CANCELAR_SERVICO_ACIMA_PRAZO_CANCELAMENTO: 12237,
  FRONT_CONFIGURAR_COLUNA_MAPA_TRANSPORTE: 12214,
  FRONT_CONFIGURAR_RECURSO_AGENDAMENTO: 12275,
  FRONT_DESBLOQUEAR_ESCALA: 12218,
  FRONT_DESCONTAR_ACIMA_PERCENTUAL_MAXIMO: 12056,
  FRONT_DEVOLVER_CREDITO_FORMA_BANCO: 12266,
  FRONT_DISPONIBILIZAR_ESCALA_APP_CLIENTE: 12216,
  FRONT_EFETUAR_DEVOLUCAO_LANCAMENTO_VENDA_GRUPO: 12066,
  FRONT_EFETUAR_ESTORNO_DEVOLUCAO_VENDA_GRUPO: 12078,
  FRONT_EFETUAR_LANCAMENTO_OS_CAIXA_FECHADO: 12065,
  FRONT_ENCERRAR_OS: 12165,
  FRONT_ESCOLHER_CATEGORIA_PAX_OS: 12261,
  FRONT_ESTORNAR_ENCERRAMENTO_OS: 12166,
  FRONT_ESTORNAR_FATURAMENTO: 12091,
  FRONT_ESTORNAR_IMPORTACAO_CVC: 12077,
  FRONT_ESTORNAR_PAGAMENTO_OS: 12274,
  FRONT_EXCLUIR_ADICAO_RETIRADA_VALOR_CAIXA_OPERACIONAL: 12129,
  FRONT_EXCLUIR_ORCAMENTO: 12198,
  FRONT_EXCLUIR_OS: 12097,
  FRONT_EXCLUIR_SERVICO_ABERTO_OS: 12084,
  FRONT_EXCLUIR_SERVICO_LANCADO_DATA_INFERIOR_IGUAL_SERVIDOR: 12168,
  FRONT_FECHAR_CAIXA: 12221,
  FRONT_FECHAR_CORTESIA: 12226,
  FRONT_IGNORAR_BLOQUEIO_MOVIMENTO_PAX_ESCALA_CUSTO_PROVISIONADO: 12263,
  FRONT_IGNORAR_CONTROLE_RIGIDO_TARIFA_SERVICO: 12053,
  FRONT_IGNORAR_OBRIGATORIEDADE_CAIXA_ABERTO_DATA_LANCAMENTO_EXTRA: 12256,
  FRONT_IGNORAR_OBRIGATORIEDADE_IGUALDADE_HORARIO_SERVICO: 12252,
  FRONT_IMPRIMIR_EXTRATO_OS: 12085,
  FRONT_IMPRIMIR_OS_FATURADO_COM_VALOR: 12088,
  FRONT_IMPRIMIR_OS_FATURADO_SEM_VALOR: 12087,
  FRONT_IMPRIMIR_OS_ITEM_ABERTO: 12086,
  FRONT_IMPRIMIR_TICKET_RECEPTIVO: 12089,
  FRONT_IMPRIMIR_VOUCHER_SERVICO_SEM_PAGAMENTO: 12194,
  FRONT_INFORMAR_COMISSAO: 12025,
  FRONT_INFORMAR_CUSTO_UNITARIO_FORNECEDOR: 12021,
  FRONT_INFORMAR_CUSTO_UNITARIO_GUIA: 12022,
  FRONT_INSERIR_ESCALA: 12131,
  FRONT_LANCAR_MASSA: 12277,
  FRONT_LANCAR_MASSA_LANCAMENTO_RAPIDO_OPCIONAL: 12279,
  FRONT_LANCAR_NOVO_SERVICO_LANCAMENTO_RAPIDO_OPCIONAL: 12278,
  FRONT_LANCAR_SERVICO_CLIENTE_BLOQUEADO: 12196,
  FRONT_LANCAR_VALOR_OUTRO_SERVICO: 12190,
  FRONT_LANCAR_VISUALIZAR_SERVICO_EXTRA: 12187,
  FRONT_LANCAR_VISUALIZAR_SERVICO_FATURADO: 12188,
  FRONT_MENU_PROCEDIMENTOS_AGENDAMENTO: 12017,
  FRONT_MENU_PROCEDIMENTOS_AGRUPAMENTO_OS_AFINIDADE: 12207,
  FRONT_MENU_PROCEDIMENTOS_ALTERACAO_MASSA: 12101,
  FRONT_MENU_PROCEDIMENTOS_AUDITORIA: 12291,
  FRONT_MENU_PROCEDIMENTOS_BLOQUEIO_SERVICO_VENDA: 12186,
  FRONT_MENU_PROCEDIMENTOS_CAIXA_OPERACIONAL: 12019,
  FRONT_MENU_PROCEDIMENTOS_COTACAO_MOEDA: 12024,
  FRONT_MENU_PROCEDIMENTOS_CONFERENCIA_CAIXA: 12148,
  FRONT_MENU_PROCEDIMENTOS_CONTROLE_ATIVIDADE_TRANSPORTE: 12285,
  FRONT_MENU_PROCEDIMENTOS_CONTROLE_EMISSAO_NF: 12139,
  FRONT_MENU_PROCEDIMENTOS_CONTROLE_PROTOCOLO_PASSAGEIRO: 12287,
  FRONT_MENU_PROCEDIMENTOS_CONTROLE_VOUCHER_FORNECEDOR: 12120,
  FRONT_MENU_PROCEDIMENTOS_COTACAO_MOEDA: 12083,
  FRONT_MENU_PROCEDIMENTOS_DIARIO_SERVICO: 12146,
  FRONT_MENU_PROCEDIMENTOS_ESCALA_SERVICO: 12050,
  FRONT_MENU_PROCEDIMENTOS_FATURAMENTO_CLIENTE: 12090,
  FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_AVULSO_SERVICO_UNICO_OS: 12208,
  FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_DISPONIBILIDADE_OPCIONAL: 12157,
  FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_EMBARQUE_GRUPO: 12063,
  FRONT_MENU_PROCEDIMENTOS_LANCAMENTO_RAPIDO_OPCIONAL: 12117,
  FRONT_MENU_PROCEDIMENTOS_MAPA_BLOQUEIO_SERVICO_VENDA: 12228,
  FRONT_MENU_PROCEDIMENTOS_MAPA_GRUPO: 12076,
  FRONT_MENU_PROCEDIMENTOS_MAPA_GUIA: 12290,
  FRONT_MENU_PROCEDIMENTOS_MAPA_OCUPACAO_APARTAMENTO: 12150,
  FRONT_MENU_PROCEDIMENTOS_MAPA_OCUPACAO_VEICULO: 12293,
  FRONT_MENU_PROCEDIMENTOS_MAPA_TRANSPORTE: 12159,
  FRONT_MENU_PROCEDIMENTOS_MAPA_VEICULO: 12049,
  FRONT_MENU_PROCEDIMENTOS_ORCAMENTO: 12137,
  FRONT_MENU_PROCEDIMENTOS_ORCAMENTO_RAPIDO: 12284,
  FRONT_MENU_PROCEDIMENTOS_ORCAMENTO_ROTEIRO: 12109,
  FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 12018,
  FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO_EVENTO: 12169,
  FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO_GENERO: 12147,
  FRONT_MENU_PROCEDIMENTOS_OS2: 12292,
  FRONT_MENU_PROCEDIMENTOS_PASSAGEIRO_TRANSPORTE: 12286,
  FRONT_MENU_PROCEDIMENTOS_PROGRAMACAO_DIARIA_SERVICO: 12219,
  FRONT_MENU_PROCEDIMENTOS_REAGENDAMENTO_SERVICO: 12142,
  FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_PRODUCAO_ESCALA_PERIODO: 12289,
  FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_PRODUCAO_VENDEDOR: 12288,
  FRONT_MENU_PROCEDIMENTOS_REGISTRA_RETORNO_ESCALA_GUIA_REGISTRO: 12257,
  FRONT_MENU_PROCEDIMENTOS_RH_REGISTRO_PONTO: 12171,
  FRONT_MENU_PROCEDIMENTOS_ROTEIRO_ESCALA: 12225,
  FRONT_MENU_PROCEDIMENTOS_TRANSFERENCIA_CREDITO: 12201,
  FRONT_MENU_PROCEDIMENTOS_TRANSFERENCIA_GRUPO_PAX: 12061,
  FRONT_MENU_PROCEDIMENTOS_VENDA_GRUPO: 12062,
  FRONT_REATIVAR_OS: 12265,
  FRONT_RECEBER_DATA_IN_SUPERIOR_CAIXA: 12079,
  FRONT_REIMPRIMIR_VOUCHER_SERVICO: 12193,
  FRONT_RETIRAR_ADICIONAR_VALOR_CAIXA_OPERACIONAL: 12026,
  FRONT_VISUALIZAR_ALTERACAO_OS: 12052,
  FRONT_VISUALIZAR_APURACAO_ESCALA: 12255,
  FRONT_VISUALIZAR_COMISSAO_CLIENTE_SERVICO: 12177,
  FRONT_VISUALIZAR_COMISSAO_EMPRESA_SERVICO: 12247,
  FRONT_VISUALIZAR_COMISSAO_VENDEDOR_SERVICO: 12178,
  FRONT_VISUALIZAR_CUSTO_ESCALA: 12167,
  FRONT_VISUALIZAR_CUSTO_SERVICO_NAO_ESCALAVEL: 12174,
  FRONT_VISUALIZAR_INCENTIVO_VENDEDOR_SERVICO: 12246,
  FRONT_VISUALIZAR_ORCAMENTO_TODO_USUARIO: 12184,

  // relatórios
  FRONT_EMITIR_RELATORIO_VENDA_GRUPO_AVULSA_SEM_NOME: 12133,
  FRONT_EXIBIR_IMPRESSAO_OUTRO_USUARIO_LISTAGEM_VOUCHER_IMPRESSO: 12199,
  FRONT_EXIBIR_SERVICO_FATURADO_TODO_EXTRATO_CONFIG_OS: 12203,
  FRONT_MENU_RELATORIOS_CONTROLE_ATIVIDADE_TRANSPORTE_CLIENTE: 12119,
  FRONT_MENU_RELATORIOS_CONTROLE_ATIVIDADE_TRANSPORTE_MOTORISTA: 12118,
  FRONT_MENU_RELATORIOS_ESCALA_ALOCACAO_VEICULO_OPCIONAL: 12260,
  FRONT_MENU_RELATORIOS_ESCALA_ALOCACAO_VEICULO_TRANSFER: 12259,
  FRONT_MENU_RELATORIOS_ESCALA_CONFIGURAVEL_TRANSPORTE: 12140,
  FRONT_MENU_RELATORIOS_ESCALA_KM_PERCORRIDO: 12258,
  FRONT_MENU_RELATORIOS_ESCALA_LISTA_ORDEM_SERVICO: 12113,
  FRONT_MENU_RELATORIOS_ESCALA_LISTA_PAX_RG: 12127,
  FRONT_MENU_RELATORIOS_ESCALA_MAPA_DIARIO: 12116,
  FRONT_MENU_RELATORIOS_ESCALA_MAPA_DIARIO_RESUMO_SERVICO: 12123,
  FRONT_MENU_RELATORIOS_ESCALA_PLANILHA_VENDA: 12210,
  FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_ANTT: 12295,
  FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_ARGENTINA: 12298,
  FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_DER: 12296,
  FRONT_MENU_RELATORIOS_ESCALA_RELACAO_PASSAGEIRO_TRANSPORTE_PARAGUAI: 12297,
  FRONT_MENU_RELATORIOS_ESCALA_ROOM_LIST: 12141,
  FRONT_MENU_RELATORIOS_ESCALA_VEICULO: 12206,
  FRONT_MENU_RELATORIOS_ESTATISTICA_PAX: 12181,
  FRONT_MENU_RELATORIOS_ESTATISTICA_SERVICO_DIA_SEMANA: 12211,
  FRONT_MENU_RELATORIOS_ESTATISTICA_TIPO_VEICULO_ESCALA: 12233,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_ADIANTAMENTO_REALIZADO: 12122,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_APURACAO_ESCALA: 12189,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_CANCELAMENTO_CAIXA: 12080,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_CREDITO_ABERTO: 12032,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_DEVOLUCAO_REALIZADA: 12268,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_EXTRATO_CONFERENCIA_LANCAMENTO_VENDEDOR: 12222,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_MOVIMENTO: 12121,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_PAGAMENTO_FORNECEDOR: 12038,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RECEBIMENTO_OS: 12135,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RECEBIMENTO_SINTETICO: 12154,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RESULTADO_APURACAO_OS: 12179,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_RESUMO_CAIXA: 12100,
  FRONT_MENU_RELATORIOS_FINANCEIRO_OPERACIONAL_SERVICO_CAIXA: 12073,
  FRONT_MENU_RELATORIOS_GERENCIAL_OPORTUNIDADE_COMERCIAL_DESTINO: 12276,
  FRONT_MENU_RELATORIOS_GERENCIAL_PROJECAO_OPERACAO_SERVICO: 12253,
  FRONT_MENU_RELATORIOS_GERENCIAL_RESUMO: 12039,
  FRONT_MENU_RELATORIOS_GRUPO_COMISSAO: 12070,
  FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_CONFERENCIA: 12064,
  FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_DATA: 12074,
  FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_RECIBO_FORNECEDOR: 12069,
  FRONT_MENU_RELATORIOS_GRUPO_EMBARQUE_RESUMO_PERIODO: 12096,
  FRONT_MENU_RELATORIOS_GRUPO_LISTAGEM_PAX: 12068,
  FRONT_MENU_RELATORIOS_GRUPO_META_PERIODO: 12299,
  FRONT_MENU_RELATORIOS_GRUPO_PAX_HOTEL_AEREO_RODOVIARIO: 12072,
  FRONT_MENU_RELATORIOS_GRUPO_PLANILHA: 12060,
  FRONT_MENU_RELATORIOS_GRUPO_RESUMO_PAX: 12095,
  FRONT_MENU_RELATORIOS_GRUPO_RESUMO_SERVICO: 12092,
  FRONT_MENU_RELATORIOS_GRUPO_ROOM_LIST_SERVICO_FATURADO: 12212,
  FRONT_MENU_RELATORIOS_GRUPO_VENDA: 12067,
  FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX: 12128,
  FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_IN_GERAL: 12098,
  FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_IN_VENDA: 12160,
  FRONT_MENU_RELATORIOS_IN_OUT_LISTA_PAX_OUT_GERAL: 12099,
  FRONT_MENU_RELATORIOS_IN_OUT_RESUMO_AEREO_RODOVIARIO_HOTEL: 12057,
  FRONT_MENU_RELATORIOS_IN_OUT_RESUMO_DIARIO_TIPO_DATA_HORARIO_SERVICO: 12134,
  FRONT_MENU_RELATORIOS_IN_OUT_ROOM_LIST_AEROPORTO_RODOVIARIO: 12030,
  FRONT_MENU_RELATORIOS_INTEGRACAO_SRVP_RJ_PRODUCAO_PACOTE: 12301,
  FRONT_MENU_RELATORIOS_LOG: 12027,
  FRONT_MENU_RELATORIOS_OPERACIONAL_COMUNICADO_PROTOCOLO_ENTREGA_DOCUMENTO_PAX: 12232,
  FRONT_MENU_RELATORIOS_OPERACIONAL_COMUNICADO_SERVICO: 12280,
  FRONT_MENU_RELATORIOS_OPERACIONAL_FICHA: 12031,
  FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_GERAL_PAX: 12172,
  FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_IMPRESSAO_VOUCHER_SERVICO: 12197,
  FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_NO_SHOW: 12191,
  FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_PAX_SERVICO: 12251,
  FRONT_MENU_RELATORIOS_OPERACIONAL_LISTAGEM_SERVICO: 12164,
  FRONT_MENU_RELATORIOS_OPERACIONAL_PAX_SERVICO_HOTEL_DATA: 12183,
  FRONT_MENU_RELATORIOS_OPERACIONAL_PAX_TRANSITO_DATA: 12093,
  FRONT_MENU_RELATORIOS_OPERACIONAL_PLACA_CHEGADA: 12175,
  FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_PAX_HOTEL: 12071,
  FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_SERVICO_ESCALAR: 12180,
  FRONT_MENU_RELATORIOS_OPERACIONAL_RESUMO_SERVICO_PREDEFINICAO_ESCALA: 12273,
  FRONT_MENU_RELATORIOS_OPERACIONAL_ROOM_LIST_DIARIO: 12029,
  FRONT_MENU_RELATORIOS_OPERACIONAL_ROOM_LIST_RESUMO: 12204,
  FRONT_MENU_RELATORIOS_OPERACIONAL_SERVICO_ABERTO: 12033,
  FRONT_MENU_RELATORIOS_OPERACIONAL_SERVICO_HOTEL_DATA: 12182,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_DEADLINE: 12114,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_ETIQUETA: 12173,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_EXTRATO_OS: 12156,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTA_OS_FORNECEDOR_TRANSPORTE: 12249,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTA_OS_PAIS: 12250,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_LISTAGEM_OS: 12161,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_MOVIMENTO_OS: 12111,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_COM_SERVICO: 12112,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_IDIOMA: 12294,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_SEM_SERVICO_DATA: 12149,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_OS_VOO_RODOVIARIO_HOTEL: 12126,
  FRONT_MENU_RELATORIOS_ORDEM_SERVICO_SALDO_OS: 12176,
  FRONT_MENU_RELATORIOS_PRODUCAO_CAIXA: 12136,
  FRONT_MENU_RELATORIOS_PRODUCAO_CLIENTE: 12036,
  FRONT_MENU_RELATORIOS_PRODUCAO_DISPONIBILIDADE_OPCIONAL_DATA: 12158,
  FRONT_MENU_RELATORIOS_PRODUCAO_FORNECEDOR_TRANSPORTE_ESCALA: 12236,
  FRONT_MENU_RELATORIOS_PRODUCAO_FORNECEDOR_TRANSPORTE_GERAL: 12035,
  FRONT_MENU_RELATORIOS_PRODUCAO_GUIA_SERVICO: 12224,
  FRONT_MENU_RELATORIOS_PRODUCAO_HOSPEDAGEM_HOTEL: 12152,
  FRONT_MENU_RELATORIOS_PRODUCAO_HOTEL_POUSADA: 12037,
  FRONT_MENU_RELATORIOS_PRODUCAO_MOTORISTA: 12162,
  FRONT_MENU_RELATORIOS_PRODUCAO_PACOTE: 12200,
  FRONT_MENU_RELATORIOS_PRODUCAO_PROJECAO_FATURAMENTO_ORCAMENTO: 12170,
  FRONT_MENU_RELATORIOS_PRODUCAO_PROMOTOR: 12300,
  FRONT_MENU_RELATORIOS_PRODUCAO_RESUMO_SERVICO_PAX_OS_PERIODO: 12094,
  FRONT_MENU_RELATORIOS_PRODUCAO_SERVICO: 12034,
  FRONT_MENU_RELATORIOS_PRODUCAO_SERVICO_CANCELADO: 12155,
  FRONT_MENU_RELATORIOS_PRODUCAO_SINTETICA_CUSTO_FORNECEDOR: 12235,
  FRONT_MENU_RELATORIOS_PRODUCAO_TARIFARIO_HOTEL: 12262,
  FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_DESEMPENHO_POTENCIAL_VENDA_GUIA: 12234,
  FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_VENDEDOR: 12028,
  FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_RESUMO: 12220,
  FRONT_MENU_RELATORIOS_PRODUCAO_VENDEDOR_SERVICO: 12143,
  FRONT_MENU_RELATORIOS_VOUCHER_MENU_SUGESTIVO_CLIENTE: 12125,
  FRONT_MENU_RELATORIOS_VOUCHER_OUTRO_FORNECEDOR_ESCALA: 12185,
  FRONT_MENU_RELATORIOS_VOUCHER_SERVICO: 12231,

  // opções
  FRONT_INSERIR_SOLUCAO_LOG_BOOK_OUTRO_USUARIO: 12223,
  FRONT_MENU_OPCOES_AGENDA_TELEFONICA: 12042,
  FRONT_MENU_OPCOES_CAMPO_OBRIGATORIO: 12303,
  FRONT_MENU_OPCOES_COPIA_SEGURANCA: 12040,
  FRONT_MENU_OPCOES_EXPORTACAO_ACQUAMOTION: 12314,
  FRONT_MENU_OPCOES_EXPORTACAO_EXTRACAO_DADO: 12227,
  FRONT_MENU_OPCOES_EXPORTACAO_GRUPO_DREAMS: 12313,
  FRONT_MENU_OPCOES_EXPORTACAO_NAPP: 12312,
  FRONT_MENU_OPCOES_EXPORTACAO_OFICINA_DIVERSAO: 12319,
  FRONT_MENU_OPCOES_EXPORTACAO_PARQUE_OLIVAS_GRAMADO: 12318,
  FRONT_MENU_OPCOES_EXPORTACAO_PDV_MOVEL_ANDROID: 12310,
  FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_GRAMADO_RS: 12202,
  FRONT_MENU_OPCOES_EXPORTACAO_SNOWLAND_WEB_SERVICE: 12311,
  FRONT_MENU_OPCOES_EXPORTACAO_SPACE_ADVENTURE: 12317,
  FRONT_MENU_OPCOES_EXPORTACAO_YUP_STAR_FOZ: 12316,
  FRONT_MENU_OPCOES_EXPORTACAO_YUP_STAR_RIO: 12315,
  FRONT_MENU_OPCOES_IMPORTACAO_AZUL_VIAGEM: 12245,
  FRONT_MENU_OPCOES_IMPORTACAO_BELA_VIAGEM: 12243,
  FRONT_MENU_OPCOES_IMPORTACAO_BOKUN: 12267,
  FRONT_MENU_OPCOES_IMPORTACAO_CIVITATIS: 12309,
  FRONT_MENU_OPCOES_IMPORTACAO_CVC: 12238,
  FRONT_MENU_OPCOES_IMPORTACAO_DECOLAR: 12244,
  FRONT_MENU_OPCOES_IMPORTACAO_ECOMMERCE_PAYTOUR: 12254,
  FRONT_MENU_OPCOES_IMPORTACAO_FRT: 12307,
  FRONT_MENU_OPCOES_IMPORTACAO_HD: 12241,
  FRONT_MENU_OPCOES_IMPORTACAO_HOTEISTUR: 12242,
  FRONT_MENU_OPCOES_IMPORTACAO_INFOTRAVEL: 12308,
  FRONT_MENU_OPCOES_IMPORTACAO_LATAM: 12239,
  FRONT_MENU_OPCOES_IMPORTACAO_LAYOUT_SISARE: 12306,
  FRONT_MENU_OPCOES_IMPORTACAO_PDV_MOVEL_ANDROID: 12305,
  FRONT_MENU_OPCOES_IMPORTACAO_SRVP_RJ: 12240,
  FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_AZUL: 12269,
  FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_LATAM: 12270,
  FRONT_MENU_OPCOES_IMPORTACAO_TRIPULACAO_SKY_AIRLINE: 12271,
  FRONT_MENU_OPCOES_IMPORTACAO_TURISCLUB_LAYOUT: 12304,
  FRONT_MENU_OPCOES_IMPORTACAO_VISUAL_TURISMO: 12248,

  FRONT_MENU_OPCOES_LOG_BOOK: 12205,
  FRONT_MENU_OPCOES_MODELO_RELATORIO: 12041,
  FRONT_MENU_OPCOES_SINCRONIZAR_COMISSAO_NOVA_FORMA: 12302,
  FRONT_MENU_OPCOES_VERIFICAR_IGUALDADE_ORDEM_SERVICO: 12215,

  // configurações
  FRONT_MENU_CONFIGURACOES_DADO_EMPRESA: 12044,
  FRONT_MENU_CONFIGURACOES_GERAL: 12043,

  /* MÓDULO FROTAS */
  // cadastro
  FROTAS_ATUALIZAR_SALDO_ESTOQUE_TANQUE_COMBUSTIVEL: 26035,
  FROTAS_INATIVAR_VEICULO: 26055,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_BOMBA_INTERNA: 26013,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_CATEGORIA_COMBUSTIVEL: 26015,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_COMBUSTIVEL: 26014,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_TANQUE_INTERNO: 26012,
  FROTAS_MENU_CADASTRO_CIDADE: 26018,
  FROTAS_MENU_CADASTRO_FORNECEDOR: 26016,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_CLIENTE: 26064,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA: 26063,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA_CLIENTE: 26065,
  FROTAS_MENU_CADASTRO_FUNCIONARIO: 26017,
  FROTAS_MENU_CADASTRO_MANUTENCAO_GRUPO_SERVICO: 26005,
  FROTAS_MENU_CADASTRO_MANUTENCAO_INSTRUCAO_PREVENTIVA: 26043,
  FROTAS_MENU_CADASTRO_MANUTENCAO_MOTIVO: 26041,
  FROTAS_MENU_CADASTRO_MANUTENCAO_SERVICO: 26006,
  FROTAS_MENU_CADASTRO_OCORRENCIA_TIPO: 26079,
  FROTAS_MENU_CADASTRO_OCORRENCIA_MOTIVO: 26087,
  FROTAS_MENU_CADASTRO_PNEU_CONDICAO: 26009,
  FROTAS_MENU_CADASTRO_PNEU_FABRICANTE: 26007,
  FROTAS_MENU_CADASTRO_PNEU_MEDIDA: 26010,
  FROTAS_MENU_CADASTRO_PNEU_MODELO: 26008,
  FROTAS_MENU_CADASTRO_PNEU_PNEU: 26011,
  FROTAS_MENU_CADASTRO_PNEU_TIPO_BORRACHA: 26078,
  FROTAS_MENU_CADASTRO_USUARIO: 26019,
  FROTAS_MENU_CADASTRO_VEICULO_MARCA: 26003,
  FROTAS_MENU_CADASTRO_VEICULO_MODELO: 26004,
  FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL: 26075,
  FROTAS_MENU_CADASTRO_VEICULO_TIPO: 26001,
  FROTAS_MENU_CADASTRO_VEICULO_VEICULO: 26002,
  FROTAS_VISUALIZAR_ABA_RH_CADASTRO_FUNCIONARIO: 26033,

  // procedimentos
  FROTAS_ALTERAR_ABASTECIMENTO: 26044,
  FROTAS_CANCELAR_REQUISICAO: 26074,
  FROTAS_CONFIRMAR_REQUISICAO: 26072,
  FROTAS_CONTROLAR_OCORRENCIA: 26059,
  FROTAS_DEVOLVER_REQUISICAO: 26073,
  FROTAS_IGNORAR_CONTROLE_RIGIDO_ABASTECIMENTO: 26057,
  FROTAS_INSERIR_ABASTECIMENTO_HODOMETRO_INFERIOR_ATUAL: 26061,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_ACERTO_ESTOQUE_COMBUSTIVEL: 26037,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_AJUSTE: 26056,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_CTF: 26054,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_INTEGRACAO_POSTO_MIME: 26080,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR: 26022,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_NF_COMBUSTIVEL: 26036,
  FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_ABASTECIMENTO_EXTERNO: 26082,
  FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_MAO_OBRA_EXTERNA: 26058,
  FROTAS_MENU_PROCEDIMENTOS_ALERTA_EMAIL_OS_PREVENTIVA: 26049,
  FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_FUNCIONARIO: 26053,
  FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_VEICULO: 26052,
  FROTAS_MENU_PROCEDIMENTOS_FRETAMENTO_CONTINUO: 26062,
  FROTAS_MENU_PROCEDIMENTOS_GERACAO_OS_PREVENTIVA: 26045,
  FROTAS_MENU_PROCEDIMENTOS_MAPA_VEICULO: 26023,
  FROTAS_MENU_PROCEDIMENTOS_MULTA: 26077,
  FROTAS_MENU_PROCEDIMENTOS_OCORRENCIA: 26081,
  FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 26021,
  FROTAS_MENU_PROCEDIMENTOS_PARCELAMENTO_PAGAR: 26069,
  FROTAS_MENU_PROCEDIMENTOS_PNEU_PARADA_MOVIMENTACAO: 26020,
  FROTAS_MENU_PROCEDIMENTOS_REQUISICAO: 26051,
  FROTAS_REABRIR_OS_ENCERRADA: 26048,

  // relatórios
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_COMPARATIVO_MES: 26046,
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_FICHA_MERCADORIA: 26042,
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_LISTAGEM: 26034,
  FROTAS_MENU_RELATORIOS_APURACAO_VEICULO: 26068,
  FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_KM_MORTO: 26085,
  FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PERIODO: 26066,
  FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PLANEJADO_REALIZADO_MES: 26067,
  FROTAS_MENU_RELATORIOS_LOG: 26030,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_EXTRATO_CUSTO_VEICULO: 26076,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_LISTAGEM: 26038,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_ORDEM_SERVICO: 26039,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PLANO: 26083,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_ABERTO: 26024,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_DETALHADA: 26027,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_GERAL: 26026,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VEICULO: 26084,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VENCER: 26025,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_REALIZADA: 26040,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_CANCELADO: 26050,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_REALIZADO: 26047,
  FROTAS_MENU_RELATORIOS_OCORRENCIA: 26060,
  FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO: 26070,
  FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO_VEICULO: 26071,

  // opções
  FROTAS_MENU_OPCOES_AJUSTAR_ABASTECIMENTO: 26086,
  FROTAS_MENU_OPCOES_COPIA_SEGURANCA: 26029,
  FROTAS_MENU_OPCOES_MODELO_RELATORIO: 26031,

  // configurações
  FROTAS_MENU_CONFIGURACOES_GERAL: 26032,

  /* MÓDULO GERENCIAL */
  // cadastro
  GERENCIAL_MENU_CADASTRO_USUARIO: 40005,

  // procedimentos
  GERENCIAL_MENU_PROCEDIMENTOS_ADMINISTRATIVO: 40004,
  GERENCIAL_MENU_PROCEDIMENTOS_FINANCEIRO: 40003,
  GERENCIAL_MENU_PROCEDIMENTOS_OPERACIONAL: 40002,
  GERENCIAL_MENU_PROCEDIMENTOS_PRODUCAO: 40001,

  // opções
  GERENCIAL_MENU_OPCOES_AGENDA_TELEFONICA: 40007,

  // configurações
  GERENCIAL_MENU_CONFIGURACOES_GERAL: 40006
};